module.exports = __webpack_public_path__ + "static/media/sky.383a5424.svg";